module.exports = __webpack_public_path__ + "img/curva.cf61a3de.svg";